export default "__VITE_ASSET__d53fe57f__"